var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DynamicIndex',{attrs:{"codeModule":'epps',"companyId":_vm.company_id,"permissionEdit":'empresa-editar-epps'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }